import { render, staticRenderFns } from "./jobfairconfirm.vue?vue&type=template&id=e98b0a76&scoped=true"
import script from "./jobfairconfirm.vue?vue&type=script&lang=js"
export * from "./jobfairconfirm.vue?vue&type=script&lang=js"
import style0 from "./jobfairconfirm.vue?vue&type=style&index=0&id=e98b0a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98b0a76",
  null
  
)

export default component.exports